import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/Users/rafaelosorio/Documents/GitHub/tech-academy-emea/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <AnchorLinks mdxType="AnchorLinks">
  <AnchorLink mdxType="AnchorLink">Goals</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Resources & Presentations</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Key Focus Areas and Targeted Skill Sets</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Agenda</AnchorLink>
    </AnchorLinks>
    <hr></hr>
    <p><strong parentName="p">{`Slack channel`}</strong>{`: #sko-tech-academy-integration-emea`}</p>
    <p><strong parentName="p">{`Join slack channel here`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://ibm-cloud.slack.com/archives/C03LS27TLNL"
      }}>{`https://ibm-cloud.slack.com/archives/C03LS27TLNL`}</a></p>
    <hr></hr>
    <h2>{`Goals`}</h2>
    <p>{`  – Develop skill to effectively plan and run a Client Facing PoC / MVP engagementusing CP4i.`}</p>
    <p>{`  – Develop skills to demonstrate IBMs marketplace differentiation in cloud-native deploymentand GitOpsAutomation.`}</p>
    <p>{`  – Develop skills for MVP Development of multi-style integration with  focus on EDA patterns.`}</p>
    <p>{`  – Develop techniques to compete with MuleSoft in a PoC activity.`}</p>
    <hr></hr>
    <h2>{`Resources & Presentations`}</h2>
    <ul>
      <li parentName="ul">
        <a href="https://ibm.box.com/s/df8xo8aow1dzyi8irhkt1vo8wz4sv03b" target="_blank">Integration Sub-Track Overview Presentation</a>
      </li>
    </ul>
    <hr></hr>
    <h2>{`Key Focus Areas and Targeted Skill Sets`}</h2>
    <p>{`Strategic capabilities and skills we will focus on:`}</p>
    <ul>
      <li parentName="ul">{`CP4i/RHOCP Design, Architecture, and Sizing Skill & tools`}</li>
      <li parentName="ul">{`IBM Event Streams, A-to-Z Demo asset & MVP Development`}</li>
      <li parentName="ul">{`GitOpsAutomation with RedHat GitOps & Pipeline Operators w/ ArgoCD and open-source components.`}</li>
    </ul>
    <hr></hr>
    <h2>{`Agenda`}</h2>
    <p>{`The high-level view of the agenda is shown in the table below.`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`The agenda is primarily divided into 3 sessions spanning approximately 12 hours of training.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Each session contains it’s own agenda with a set of activities with 4 hours duration.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Using the left navigator, you can view the individual sessions details.`}</p>
      </li>
    </ul>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Time`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Topic`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`10 min`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Kickoff:`}</strong>{` Welcome, Introduction and overview of the training activities for the Integration Portfolio`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`4 hours`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Architectute Session:`}</strong>{` Designing, Architecting & Sizing an Enterprise Grade CP4I Configuration`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`4 hours`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`EDA Session:`}</strong>{` MVP Development Using Event Driven Architecture Practices, Real-time Inventory Management`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`4 hours`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`GitOps Automation Session:`}</strong>{` Agile Integration Best Practices Using an IBM GitOps Automation Framework`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`20 min`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Wrap-up:`}</strong>{` Selection of short demos from teams & Wrap-up`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      